module.exports = __webpack_public_path__ + "img/diamante.77a57423.png";